<template>
  <div class="product_image">
    <img width="100%" :src="photo" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ProductImage",
  props: {
    msg: String
  },
  computed: {
    ...mapGetters(["activeProductDetails"]),
    details() {
      return this.activeProductDetails || {};
    },
    photo: function() {
      return (
        this.details.PhotoDomain +
        "w_1280,h_840,c_fill" +
        "/v" +
        this.details.PhotoVersion +
        this.details.PhotoFolder +
        "/original"
      );
    }
  }
};
</script>

<style lang="scss"></style>
